import type { PulseShareType, PulseShareUser } from '../types/pulse-share'

export const canAccessType =
  (type: PulseShareType) =>
  (user: PulseShareUser): boolean => {
    return user.shareType === type
  }
